import type {Image} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/image.types';
import {HCIcons} from './icons';

// The category ID in Zendesk for the new SSF articles/sections
const HELP_CENTER_SSF_CATEGORY_ID = 4493942872220;

export const SSF_SCOPED_PARAM = `?categoryId=${HELP_CENTER_SSF_CATEGORY_ID}`;

export const SECTION_ID_TO_ICON_MAPPING: Record<number, Image> = {
  4498263610012: {url: HCIcons.basket, description: '', external: false},
  4498298648732: {url: HCIcons.account, description: '', external: false},
  4498333630748: {url: HCIcons.delivery, description: '', external: false},
  4498263998236: {url: HCIcons.parcel, description: '', external: false},
  4498334895004: {
    url: HCIcons.orderAndRefund,
    description: '',
    external: false,
  },
  4498320777628: {url: HCIcons.parcelReturn, description: '', external: false},
  4498328796188: {url: HCIcons.tracking, description: '', external: false},
  4498366371228: {url: HCIcons.warning, description: '', external: false},
  4498340173724: {
    url: HCIcons.orderAndRefund,
    description: '',
    external: false,
  },
  4588620259612: {
    url: HCIcons.missingArticle,
    description: '',
    external: false,
  },
  4588675642652: {url: HCIcons.articleWrong, description: '', external: false},
  4588690215580: {
    url: HCIcons.articleDamaged,
    description: '',
    external: false,
  },
  4588654050076: {url: HCIcons.clothHang, description: '', external: false},
  4588717965980: {url: HCIcons.returnLabel, description: '', external: false},
  4588746238236: {url: HCIcons.delivery, description: '', external: false},
  4588655521308: {
    url: HCIcons.orderAndRefund,
    description: '',
    external: false,
  },
  4588656334620: {url: HCIcons.tracking, description: '', external: false},
  4588756106780: {url: HCIcons.danger, description: '', external: false},
  4588778463260: {url: HCIcons.warning, description: '', external: false},
  4588758287644: {url: HCIcons.personalData, description: '', external: false},
  4588766753948: {
    url: HCIcons.orderAndRefund,
    description: '',
    external: false,
  },
  4588758641436: {url: HCIcons.danger, description: '', external: false},
  4588759500060: {url: HCIcons.newsletter, description: '', external: false},
  4588767374364: {url: HCIcons.bin, description: '', external: false},
  5154886472348: {url: HCIcons.parcelReturn, description: '', external: false},
  5155547225244: {url: HCIcons.cod, description: '', external: false},
  8507743993372: {
    url: HCIcons.higherPriceCheckout,
    description: '',
    external: false,
  },
  8509201279772: {url: HCIcons.coupons, description: '', external: false},
  8509292611356: {
    url: HCIcons.orderByPhoneSocial,
    description: '',
    external: false,
  },
  8509374955932: {
    url: HCIcons.orderConfirmationMissing,
    description: '',
    external: false,
  },
};

export const SECTION_ID_TO_SECTIONS_DESCRIPTION: Record<number, number[]> = {
  4498263610012: [4498328796188, 4588656334620, 4588717965980],
  4498298648732: [4588758287644, 4588766753948, 4588759500060],
  4498333630748: [4498328796188, 4498366371228, 4498340173724],
  4498263998236: [4588620259612, 4588675642652, 4588690215580, 4588654050076],
  4498334895004: [4588746238236, 4588655521308, 4588717965980],
  4498320777628: [4588656334620, 4588756106780, 4588778463260],
};

export const HIGHLIGHTED_SSF_ARTICLES = [
  360014815259, 360014814359, 360014777080, 360014814279,
];
